/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ConfigCatalog { 
    id?: string;
    configKey: string;
    name: string;
    description?: string;
    category: string;
    configType: string;
    defaultValue?: object;
    validationSchema?: object;
    isRequired: boolean;
    isSystem: boolean;
    icon?: string;
    orderIndex: number;
    isActive: boolean;
    createdOn: string;
    modifiedOn: string;
}

